import "core-js/modules/es.array.push.js";
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-5b951bae"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "home"
};
const _hoisted_2 = {
  class: "section1 bak"
};
const _hoisted_3 = {
  class: "common"
};
const _hoisted_4 = {
  class: "content"
};
const _hoisted_5 = {
  class: "text_wrap"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text2"
}, "用卫星科技联接人与自然", -1));
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text3"
}, "Connecting people and nature with satellite technology ", -1));
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<section class=\"section2\" data-v-5b951bae><div class=\"common center\" data-v-5b951bae><span class=\"text1\" data-v-5b951bae>聚焦卫星物联网，提供空天地一体化解决方案</span><div class=\"line\" data-v-5b951bae><div class=\"group\" data-v-5b951bae><b class=\"img _1 bak\" data-v-5b951bae></b><span class=\"txt\" data-v-5b951bae>中国第一家专注卫星通信与网络的民企</span></div><div class=\"group\" data-v-5b951bae><b class=\"img _2 bak\" data-v-5b951bae></b><span class=\"txt\" data-v-5b951bae>唯一进入国家任务核心部件供应的民企</span></div></div><div class=\"line\" data-v-5b951bae><div class=\"group\" data-v-5b951bae><b class=\"img _3 bak\" data-v-5b951bae></b><span class=\"txt\" data-v-5b951bae>中国第一个业务运行的卫星物联网体制</span></div><div class=\"group\" data-v-5b951bae><b class=\"img _4 bak\" data-v-5b951bae></b><span class=\"txt\" data-v-5b951bae>中国第一批全球应用的卫星物联网终端</span></div><div class=\"group\" data-v-5b951bae><b class=\"img _5 bak\" data-v-5b951bae></b><span class=\"txt\" data-v-5b951bae>20年积累全自主技术的快速迭代能力</span></div></div></div></section>", 1);
const _hoisted_9 = {
  class: "section-solution bak section"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "title-solution"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, "解决方案"), /*#__PURE__*/_createElementVNode("b", {
  class: "dec"
})], -1));
const _hoisted_11 = {
  class: "solution-wrap"
};
const _hoisted_12 = {
  class: "content"
};
const _hoisted_13 = {
  class: "main"
};
const _hoisted_14 = {
  class: "solution-title"
};
const _hoisted_15 = {
  class: "text"
};
const _hoisted_16 = {
  class: "text text2"
};
const _hoisted_17 = ["onClick"];
const _hoisted_18 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "查看详情", -1));
const _hoisted_19 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("b", {
  class: "icon bak"
}, null, -1));
const _hoisted_20 = [_hoisted_18, _hoisted_19];
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, "更多解决方案", -1));
const _hoisted_22 = [_hoisted_21];
const _hoisted_23 = {
  class: "section-success-case section"
};
const _hoisted_24 = {
  class: "common center"
};
const _hoisted_25 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "title"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, "成功案例"), /*#__PURE__*/_createElementVNode("b", {
  class: "dec"
})], -1));
const _hoisted_26 = {
  class: "list"
};
const _hoisted_27 = ["onClick"];
const _hoisted_28 = {
  class: "bottom"
};
const _hoisted_29 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, "更多成功案例", -1));
const _hoisted_30 = [_hoisted_29];
const _hoisted_31 = {
  class: "section-service section"
};
const _hoisted_32 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "title"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, "平台服务"), /*#__PURE__*/_createElementVNode("b", {
  class: "dec"
})], -1));
const _hoisted_33 = {
  class: "list"
};
const _hoisted_34 = ["onClick"];
const _hoisted_35 = {
  class: "content"
};
const _hoisted_36 = {
  class: "text"
};
const _hoisted_37 = {
  class: "section-cooperate section"
};
const _hoisted_38 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "title"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, "合作伙伴"), /*#__PURE__*/_createElementVNode("b", {
  class: "dec"
})], -1));
const _hoisted_39 = {
  class: "list"
};
const _hoisted_40 = {
  class: "row"
};
const _hoisted_41 = {
  class: "row"
};
const _hoisted_42 = {
  class: "row"
};
const _hoisted_43 = {
  class: "section-news section"
};
const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "title"
}, [/*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, "新闻中心"), /*#__PURE__*/_createElementVNode("b", {
  class: "dec"
})], -1));
const _hoisted_45 = {
  class: "list"
};
const _hoisted_46 = ["onClick"];
const _hoisted_47 = {
  class: "content"
};
const _hoisted_48 = {
  class: "news-title"
};
const _hoisted_49 = {
  class: "time"
};
const _hoisted_50 = {
  class: "text"
};
const _hoisted_51 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "text"
}, "更多新闻", -1));
const _hoisted_52 = [_hoisted_51];
import { Swiper, SwiperSlide } from 'swiper/vue/swiper-vue';
import { Navigation, Autoplay } from 'swiper';
import { scrollToAnchor } from '@/utils';
import solution from '@/data/solution';
import cases from '@/data/cases';
import news from './news';
import deviceMap from '@/views/device-detail/data/product';
import software from '@/data/software';
import { onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
export default {
  __name: 'home',
  setup(__props) {
    const modules = [Navigation, Autoplay];
    const router = useRouter();
    const $route = useRoute();
    const cases2 = [cases[0], cases[1], cases[2]];
    onMounted(() => {
      const anchor = $route.query.anchor;
      if (anchor) {
        scrollToAnchor('#' + anchor);
      }
    });
    const clickNewsItem = index => {
      router.push({
        path: `/news-detail/${index}`
      });
    };
    const linkToMoreNews = () => {
      router.push({
        name: 'news-list'
      });
    };
    const linkToMoreCase = () => {
      router.push({
        name: 'cases'
      });
    };
    const linkToMoreSolution = () => {
      router.push({
        name: 'solution'
      });
    };
    const linkToCaseDetail = index => {
      router.push({
        path: `/cases/${index}`
      });
    };
    const linkToSolutionDetail = id => {
      router.push({
        path: `/solution/${id}`
      });
    };
    const linkToDeviceDetail = id => {
      router.push({
        name: 'device-detail',
        params: {
          id
        }
      });
    };
    const linkToSoftware = id => {
      router.push({
        path: `software/${id}`
      });
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = (...args) => _ctx.test && _ctx.test(...args)),
        class: "text1"
      }, "空天一体化解决方案"), _hoisted_6, _hoisted_7])])])]), _hoisted_8, _createElementVNode("section", _hoisted_9, [_hoisted_10, _createVNode(_unref(Swiper), {
        class: "swiper-container",
        index: 3,
        modules: modules,
        centeredSlides: true,
        slidesPerView: 2,
        spaceBetween: 50,
        navigation: true,
        pagination: {
          clickable: true
        },
        loop: true,
        speed: 400,
        observer: "",
        observeParents: "",
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
          pauseOnMouseEnter: true
        }
      }, {
        default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(solution), (item, index) => {
          return _openBlock(), _createBlock(_unref(SwiperSlide), {
            key: index,
            class: "swiper-slide"
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createElementVNode("span", {
              class: "img bak",
              style: _normalizeStyle(`background-image: url(${item.homeImg})`)
            }, null, 4), _createElementVNode("div", _hoisted_12, [_createElementVNode("div", _hoisted_13, [_createElementVNode("h3", _hoisted_14, _toDisplayString(item.title), 1), _createElementVNode("p", _hoisted_15, _toDisplayString(item.pain), 1), _createElementVNode("p", _hoisted_16, _toDisplayString(item.solution), 1)]), _createElementVNode("div", {
              class: "goto_detail",
              onClick: $event => linkToSolutionDetail(index)
            }, _hoisted_20, 8, _hoisted_17)])])]),
            _: 2
          }, 1024);
        }), 128))]),
        _: 1
      }), _createElementVNode("div", {
        class: "goto_more_btn",
        onClick: linkToMoreSolution
      }, _hoisted_22)]), _createElementVNode("section", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_hoisted_25, _createElementVNode("ul", _hoisted_26, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(cases2, (item, index) => {
        return _createElementVNode("li", {
          key: index,
          class: "item bak",
          style: _normalizeStyle(`background-image: url(${item.homeImg})`),
          onClick: $event => linkToCaseDetail(index)
        }, [_createElementVNode("div", _hoisted_28, _toDisplayString(item.homeText), 1)], 12, _hoisted_27);
      }), 64))]), _createElementVNode("div", {
        class: "goto_more_btn",
        onClick: _cache[1] || (_cache[1] = $event => linkToMoreCase())
      }, _hoisted_30)])]), _createElementVNode("section", _hoisted_31, [_hoisted_32, _createElementVNode("ul", _hoisted_33, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(software), (item, index) => {
        return _openBlock(), _createElementBlock("li", {
          key: index,
          class: "item bak",
          style: _normalizeStyle(`background-image: url(${item.homeImg})`),
          onClick: $event => linkToSoftware(index)
        }, [_createElementVNode("div", _hoisted_35, [_createElementVNode("b", {
          class: "icon bak",
          style: _normalizeStyle(`background-image: url(${item.homeIcon})`)
        }, null, 4), _createElementVNode("span", _hoisted_36, _toDisplayString(item.title), 1)])], 12, _hoisted_34);
      }), 128))])]), _createElementVNode("section", _hoisted_37, [_hoisted_38, _createElementVNode("div", _hoisted_39, [_createElementVNode("div", _hoisted_40, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, index => {
        return _createElementVNode("div", {
          key: index,
          class: "item bak",
          style: _normalizeStyle(`background-image: url(${require(`@/assets/home/1-${index}.png`)})`)
        }, null, 4);
      }), 64))]), _createElementVNode("div", _hoisted_41, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, index => {
        return _createElementVNode("div", {
          key: index,
          class: "item bak",
          style: _normalizeStyle(`background-image: url(${require(`@/assets/home/2-${index}.png`)})`)
        }, null, 4);
      }), 64))]), _createElementVNode("div", _hoisted_42, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, index => {
        return _createElementVNode("div", {
          key: index,
          class: "item bak",
          style: _normalizeStyle(`background-image: url(${require(`@/assets/home/3-${index}.png`)})`)
        }, null, 4);
      }), 64))])])]), _createElementVNode("section", _hoisted_43, [_hoisted_44, _createElementVNode("div", _hoisted_45, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(news), (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          key: index,
          class: "item",
          onClick: $event => clickNewsItem(index)
        }, [_createElementVNode("span", {
          class: "img bak",
          style: _normalizeStyle(`background-image: url(${item.img})`)
        }, null, 4), _createElementVNode("div", _hoisted_47, [_createElementVNode("h3", _hoisted_48, _toDisplayString(item.title), 1), _createElementVNode("span", _hoisted_49, _toDisplayString(item.time), 1), _createElementVNode("p", _hoisted_50, _toDisplayString(item.desc), 1)])], 8, _hoisted_46);
      }), 128))]), _createElementVNode("div", {
        class: "btn_group"
      }, [_createElementVNode("div", {
        class: "goto_more_btn",
        onClick: linkToMoreNews
      }, _hoisted_52)])])]);
    };
  }
};